import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private config: MatSnackBarConfig;

  constructor(private snackbar: MatSnackBar, private zone: NgZone) {
    this.config = new MatSnackBarConfig();
    this.config.panelClass = ['snackbar-container'];
    this.config.verticalPosition = 'top';
    this.config.horizontalPosition = 'right';
    this.config.duration = 4000;
  }

  public error(message: string): void {
    this.config.panelClass = ['snackbar-container', 'error'];
    this.show(message);
  }

  public success(message: string): void {
    this.config.panelClass = ['snackbar-container', 'success'];
    this.show(message);
  }

  public warning(message: string): void {
    this.config.panelClass = ['snackbar-container', 'warning'];
    this.show(message);
  }

  private show(message: string, config?: MatSnackBarConfig): void {
    config = config || this.config;
    this.zone.run(() => {
      this.snackbar.open(message, 'Close', config);
    });
  }
}
